import { Box, Container, Divider, Typography } from '@material-ui/core';

// Política de Privacidade PÚBLICA (sem login) — URL exigida pelas lojas
// Apple App Store e Google Play para os apps 4LogX Driver e 4LogX
// Operation. Acessível em /privacidade.

const Section = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <Box mt={4}>
    <Typography variant="h6" gutterBottom style={{ fontWeight: 700 }}>
      {title}
    </Typography>
    <Typography
      variant="body1"
      component="div"
      style={{ lineHeight: 1.7, color: '#3c4b4e' }}
    >
      {children}
    </Typography>
  </Box>
);

export const PrivacyPolicy = () => (
  <Box style={{ background: '#f4f6f7', minHeight: '100vh' }} pb={8}>
    <Box
      style={{ background: '#17457c' }}
      py={4}
      mb={4}
      display="flex"
      justifyContent="center"
    >
      <Typography variant="h4" style={{ color: '#fff', fontWeight: 700 }}>
        Política de Privacidade
      </Typography>
    </Box>

    <Container maxWidth="md">
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Plataforma 4LogX — portal web e aplicativos 4LogX Driver e 4LogX
        Operation · Última atualização: 11 de outubro de 2026
      </Typography>

      <Section title="1. Quem somos">
        A plataforma 4LogX é uma solução de gestão logística operada pela
        4Innovation Tecnologia, utilizada por empresas contratantes
        (transportadoras e locadoras) e seus colaboradores — operadores de
        armazém e motoristas — por meio do portal web e dos aplicativos
        <b> 4LogX Driver</b> (br.com.logx4.driver) e <b>4LogX Operation</b>{' '}
        (br.com.logx4.operation).
      </Section>

      <Section title="2. Dados que coletamos">
        <ul style={{ paddingLeft: 20 }}>
          <li>
            <b>Dados de identificação</b>: nome, e-mail, CPF e vínculo com a
            empresa contratante, fornecidos no cadastro do usuário.
          </li>
          <li>
            <b>Localização (GPS)</b>: durante a execução de rotas no 4LogX
            Driver, a localização do dispositivo é coletada — inclusive em
            segundo plano enquanto houver rota ativa — para rastreamento da
            entrega, navegação e registro do local de finalização. A coleta
            cessa fora da jornada de rotas.
          </li>
          <li>
            <b>Fotos e assinatura</b>: imagens capturadas pela câmera no
            momento da entrega, devolução ou ocorrência (podendo conter
            carimbo de localização, data e hora) e a assinatura do recebedor,
            como comprovação do serviço.
          </li>
          <li>
            <b>Dados operacionais</b>: pedidos, itens, códigos de barras/RFID
            bipados, horários de início e término das atividades e mensagens
            trocadas na Central de Mensagens.
          </li>
        </ul>
      </Section>

      <Section title="3. Para que usamos os dados">
        Os dados são usados exclusivamente para a operação logística:
        comprovação de entregas e coletas, rastreamento de rotas em
        andamento, geração de relatórios e comprovantes para os clientes da
        empresa contratante, comunicação entre portal e motorista e melhoria
        da segurança da operação. Não vendemos dados pessoais nem os usamos
        para publicidade.
      </Section>

      <Section title="4. Compartilhamento">
        Os dados pertencem à empresa contratante da plataforma e são
        compartilhados apenas: (a) com a própria empresa contratante e seus
        usuários autorizados; (b) com o cliente final da entrega, quando
        recebe o comprovante do serviço (fotos, assinatura, horários); e (c)
        com provedores de infraestrutura estritamente necessários à operação
        (hospedagem e armazenamento), sob contrato.
      </Section>

      <Section title="5. Armazenamento e segurança">
        Os dados trafegam criptografados (HTTPS) e ficam armazenados em
        servidores com acesso controlado. Os aplicativos guardam dados
        localmente no dispositivo apenas para funcionamento off-line e os
        sincronizam quando há conexão. O acesso ao portal e aos aplicativos
        exige autenticação.
      </Section>

      <Section title="6. Retenção e exclusão">
        Os dados operacionais são mantidos pelo período necessário à
        comprovação dos serviços e ao cumprimento de obrigações legais da
        empresa contratante. O usuário pode solicitar a exclusão da sua
        conta e dos seus dados pessoais pelo canal de contato abaixo; a
        exclusão é atendida nos termos da LGPD, ressalvadas as hipóteses
        legais de retenção.
      </Section>

      <Section title="7. Seus direitos (LGPD)">
        Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018),
        você pode solicitar a confirmação de tratamento, o acesso, a
        correção, a anonimização ou a exclusão dos seus dados pessoais, bem
        como revogar consentimentos. As permissões de localização, câmera e
        notificações podem ser revogadas a qualquer momento nas
        configurações do dispositivo — algumas funções do aplicativo podem
        deixar de operar sem elas.
      </Section>

      <Section title="8. Contato">
        Para exercer seus direitos ou tirar dúvidas sobre esta política,
        entre em contato com o encarregado de dados pelo e-mail{' '}
        <b>contato@4logistica.com.br</b>.
      </Section>

      <Box mt={5}>
        <Divider />
        <Typography
          variant="caption"
          color="textSecondary"
          component="div"
          style={{ marginTop: 12 }}
        >
          Esta política pode ser atualizada; a versão vigente estará sempre
          disponível nesta página.
        </Typography>
      </Box>
    </Container>
  </Box>
);
